import * as React from 'react';
import styled from 'styled-components';
import { HelpText } from '../onlineForm/onlineForm';

const SConnectedBulletsList = styled.div(
  ({ theme }) => `  
  width: 100%;
  font-family: Poppins;
  font-weight: 300;
  font-size: ${theme.font.size.smallMedium};
  line-height: 17px;
  color: ${theme.colors.primaryBackground};
  display: flex;
  flex-direction: column;
  align-items: center;
`
);

const SBullet = styled.div<{ connected: boolean }>(
  ({ theme, connected }) => `  
    font-weight: 400;
    border-left: 2px solid ${connected ? theme.colors.disabledBG : 'transparent'};
    font-weight: ${theme.font.weight.bold};
    display: flex;
    padding-bottom: 20px;
    width: 88%;
    &:before {
        content: attr(data-sign);
        font-family: Poppins;
        display: block;
        font-size: 13px;
        line-height: 21px;
        background: ${theme.colors.primaryBright};
        color: ${theme.colors.white};
        border-radius: 50px;
        display: block;
        height: 20px;
        width: 20px;
        margin-left: -11px;
        margin-right: 10px;
        text-align: center;
        flex-shrink: 0;
        font-weight: 600;
    }
  `
);

const SBulletText = styled.div(
  ({ theme }) => `  
    display: flex;
    flex-direction: column;
    ${HelpText} {
      margin-top: 10px;
      text-align: left;
      line-height: 18px;
    }
  `
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

export default (props) => {
  return (
    <SConnectedBulletsList>
      {props.bullets.map((bullet, index) => {
        return (
          <SBullet
            key={`bullet-${index}`}
            data-sign={(index + 1).toString()}
            connected={index < props.bullets.length - 1}
          >
            <SBulletText>{bullet}</SBulletText>
          </SBullet>
        );
      })}
    </SConnectedBulletsList>
  );
};
